import * as Yup from "yup";
import { BadgeCriteriaType } from "helpers/constants";

export const initialValues = {
  badgeName: "",
  badgeDescription: "",
  badgeIconUrl: "",
  criteriaType: BadgeCriteriaType.FEEDBACK_COUNT,
  criteriaValue: 0,
};

export const getValidationSchema = () =>
  Yup.object().shape({
    badgeName: Yup.string().required("This field is required"),
    badgeDescription: Yup.string(),
    badgeIconUrl: Yup.string(),
    criteriaType: Yup.string().required("This field is required"),
    criteriaValue: Yup.number()
      .required("This field is required")
      .integer("Must be a whole number")
      .min(1, "Must be at least 1"),
  });
